import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';

import { useResource } from 'app/common/api';
import { TPageable } from 'app/common/constraints/core/constraints';
import { usePageNotify } from 'app/common/notifications/features/page-notifications';

import { TProfileConstraints } from '../../core/profile-constraints';
import { TTerminalProfile } from '../../core/profiles';
import { getProfilesRequest } from '../../requests';
import { UiSelectTerminalProfile } from '../../ui/ui-select-terminal-profile';

type AvailableTerminalProfilesProps = {
  value?: TTerminalProfile;
  onChange?: (terminalType: TTerminalProfile) => void;
  displayLoader?: boolean;
};

export const AvailableTerminalProfiles = observer(
  ({ value, onChange }: AvailableTerminalProfilesProps) => {
    const [items, setItems] = useState<TTerminalProfile[]>([]);
    const errorNotify = usePageNotify();

    const getTerminalProfilesResource = useResource<
      TProfileConstraints,
      TPageable<TTerminalProfile[]>
    >({
      request: getProfilesRequest,
      errorNotify: errorNotify,
      onDone(result) {
        setItems(result.content);
      },
    });

    const handleChange = (values: TTerminalProfile) => {
      onChange && onChange(values);
    };

    const isLoading = getTerminalProfilesResource.isLoading;

    useEffect(() => {
      getTerminalProfilesResource.send({ filter: null, sorting: [] });
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
      <UiSelectTerminalProfile
        loading={isLoading}
        items={items}
        value={value}
        onChange={handleChange}
      />
    );
  }
);
